
(function () {
  "use strict";

  const KEY = "hd_attribution_v1";
  const DAY = 86400000;
  const ROOT = window.Shopify?.routes?.root || "/";
  let timer;
  let running = false;

  const FIELDS = {
    source: "Source",
    medium: "Medium",
    campaign: "Campaign",
    campaignId: "Campaign ID",
    ad: "Ad",
    adId: "Ad ID",
    adset: "Ad set",
    adsetId: "Ad set ID",
    placement: "Placement",
    landing: "Landing",
    time: "Date"
  };

  function allowed() {
    const p = window.Shopify?.customerPrivacy;
    return Boolean(
      p?.marketingAllowed?.() &&
      p?.analyticsProcessingAllowed?.()
    );
  }

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "null");
    } catch {
      return null;
    }
  }

  function fresh(touch, days) {
    if (!touch?.time) return false;
    const date = Date.parse(touch.time);
    return Number.isFinite(date) &&
      Date.now() - date < days * DAY;
  }

  function getTouch() {
    const query = new URLSearchParams(location.search);

    const value = key =>
      (query.get(key) || "")
        .replace(/[\r\n\t<>]/g, " ")
        .slice(0, 150);

    let referrer = "";

    try {
      const host = new URL(document.referrer).hostname;
      if (host && host !== location.hostname) {
        referrer = host.replace(/^www\./, "");
      }
    } catch {}

    const googleClick = ["gclid", "gbraid", "wbraid"]
      .some(key => query.has(key));

    const metaClick = query.has("fbclid");

    const tagged = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_id"
    ].some(key => query.has(key));

    const platforms = {
      fb: "facebook",
      ig: "instagram",
      msg: "messenger",
      an: "audience_network",
      th: "threads"
    };

    const rawSource = value("utm_source");

    return {
      source:
        platforms[rawSource] ||
        rawSource ||
        (googleClick ? "google" :
         metaClick ? "meta" :
         referrer || "direct"),

      medium:
        value("utm_medium") ||
        (googleClick ? "cpc" :
         metaClick ? "unknown" :
         referrer.includes("google.") ? "organic" :
         referrer ? "referral" : "direct"),

      campaign: value("utm_campaign"),
      campaignId: value("utm_id"),
      ad: value("utm_content"),
      adId: value("ad_id"),
      adset: value("utm_term"),
      adsetId: value("adset_id"),
      placement: value("placement"),
      landing: location.pathname,
      time: new Date().toISOString(),

      external: Boolean(
        tagged || googleClick || metaClick || referrer
      )
    };
  }

  function attributes(data) {
    const result = {};

    for (const [prefix, touch] of [
      ["First", data?.first || {}],
      ["Last", data?.last || {}]
    ]) {
      for (const [field, label] of Object.entries(FIELDS)) {
        result["HD " + prefix + " " + label] =
          String(touch[field] || "");
      }
    }

    return result;
  }

  async function updateCart(values, clear = false) {
    const response = await fetch(ROOT + "cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!response.ok) throw new Error("Cart read failed");

    const cart = await response.json();

    if (!clear && !cart.item_count) return;

    const changed = {};

    for (const [key, value] of Object.entries(values)) {
      if ((cart.attributes?.[key] || "") !== value) {
        changed[key] = value;
      }
    }

    if (!Object.keys(changed).length) return;

    const result = await fetch(ROOT + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ attributes: changed })
    });

    if (!result.ok) {
      throw new Error("Cart attribution update failed");
    }
  }

  async function sync() {
    if (running) return;
    running = true;

    try {
      if (!allowed()) {
        const previous = read();
        localStorage.removeItem(KEY);

        if (previous) {
          await updateCart(attributes({}), true);
        }
        return;
      }

      const touch = getTouch();
      const data = read() || {};

      if (!fresh(data.first, 30)) {
        data.first = touch;
      }

      // Last = paskutinis išorinis šaltinis.
      // Tiesioginis sugrįžimas jo neperrašo 7 dienas.
    
const fields = [
  "source", "medium", "campaign",
  "campaignId", "ad", "adId",
  "adset", "adsetId", "placement", "landing"
];

const changed = fields.some(key =>
  String(data.last?.[key] || "") !==
  String(touch[key] || "")
);

if (
  !fresh(data.last, 7) ||
  (touch.external && changed)
) {
  data.last = touch;
}

      localStorage.setItem(KEY, JSON.stringify(data));
      await updateCart(attributes(data));

    } catch (error) {
      console.warn("[HD Attribution]", error);
    } finally {
      running = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  document.addEventListener(
    "visitorConsentCollected",
    schedule
  );

  document.addEventListener(
    "shopifyCustomerPrivacyApiLoaded",
    schedule
  );


  document.addEventListener("click", event => {
    if (event.target.closest(
      'button[name="add"], [data-add-to-cart], ' +
      'form[action*="/cart/add"] button[type="submit"]'
    )) {
      setTimeout(schedule, 800);
    }
  }, true);

  setTimeout(schedule, 500);
  setTimeout(schedule, 1800);
})();
